module.exports = __webpack_public_path__ + "img/Teng.7eac7c6c.jpeg";